<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="flex items-center justify-between mb-5 p-4 bg-gray-50 rounded-xl border border-gray-200">
    <div class="flex items-center gap-3">
      <i class="pi pi-clock text-purple-600" style="font-size: 20px;"></i>
      <div>
        <label class="block text-sm font-semibold text-gray-800 cursor-pointer">Pay Later</label>
        <p class="text-xs text-gray-500">This is for manual order. Customer will pay at a later time.</p>
      </div>
    </div>
    <label class="relative inline-flex items-center cursor-pointer">
      <input 
        :checked="modelValue" 
        @change="emit('update:modelValue', $event.target.checked)"
        type="checkbox" 
        class="toggle" 
      />
      <span class="ml-3 text-sm font-medium text-gray-700">{{ modelValue ? 'Enabled' : 'Disabled' }}</span>
    </label>
  </div>
</template>

<style scoped>
input.toggle:checked {
  background-color: #a855f7 ;
}
</style>
